import type { DataEvent } from './schemas'

import { v4 as uuidv4 } from 'uuid'
import { message } from './model'
import { AnyEventVariant, DataEventType } from './schemas'

export * as model from './model'
export * from './schemas'

//
// test sse events without actual sse events
//

const ssevent =
  (type: DataEventType) => (id: number, id1?: number, id2?: number) =>
    message({
      event: AnyEventVariant.data,
      id: uuidv4(),
      data: {
        type,
        itemId: id,
        metadata: {
          tvShowId: id1,
          seasonId: id2,
        },
      },
    } as DataEvent)

const sse: any = (globalThis.sse = {})
Object.entries(DataEventType).forEach(([key, value]) => {
  sse[key] = ssevent(value)
})
